import React, { useState, useEffect, useRef, useContext } from 'react';
import 'react-multi-carousel/lib/styles.css';
import { DOC_ARRAY_AADHAR, DOC_ARRAY_PAN } from '../documents/constant';
import UploadDocCard from './upload-doc-card';
import PreviewComponent from './preview-image';
import '../documents/document.scss';
import { deleteDocumentsForSummary, fetchOrder } from 'home/view/manage-feasibility/services';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { DEFAULT_TOAST_MSG, ERROR_TOAST, MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import { AppContext } from 'App';
//import PopupComponent from "../../../components/functional/pop-up/popup.component";
const UploadDocuments = (props) => {
  let {
    uploadedDoc = {},
    setUploadedDoc,
    selectedDocumentType,
    order,
    setSelectedOption,
    options,
    setKdmAccordionValidation,
    setIsSaveBtnDisabled,
    fetchOrderFn,
    kdmImagePresent,
    companyGstValidation
  } = props;
  const childRef = useRef();
  let documentArray = selectedDocumentType && selectedDocumentType.id === 'aadhaar' ? DOC_ARRAY_AADHAR : DOC_ARRAY_PAN;
  const [showPopUp, setTogglePopUp] = useState(false);
  const [imageUrl, setPopupImageUrl] = useState('');
  const [showClearPopup, setClearShowPopup] = useState(false);
  const [sliderIndex, setSliderIndex] = useState(0);

  const [documentObjList, setDocumentArray] = useState(documentArray);
  const [showAllDocUpload, setAllDocUpload] = useState(false);
  const [showPopupBox, setShowPopupBox] = useState(false);
  const [showConfirmationPopupBox, setConfirmationPopupBox] = useState('');
  const [showToastMessage, setToastMessage] = useState(false);
  const [showChangePlanPopupBox, setShowChangePlanPopupBox] = useState(false);
  // const [uploadedDoc, setUploadedDoc] = useState({});
  const [getOrderedImages, setOrderedImages] = useState([]);

  const { setToast } = useContext(AppContext);

  const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  // const getDefaultSelectedOption = () =>{
  //     const docs = order?.document?.AUTHORIZED_SIGNATORY;
  //     if(docs)
  //     {
  //         const docsType = docs[0].split("_")[0];
  //         if(docsType === "PAN")
  //         {
  //             setSelectedOption(options[0])
  //         }else{
  //             setSelectedOption(options[1])
  //         }
  //     }
  // }

  const getDefaultUploadedDocs = () => {
    order?.document?.AUTHORIZED_SIGNATORY;
  };

  const toggleClearPopUp = () => {
    setClearShowPopup(!showClearPopup);
  };

  // const uploadedDocsObj = () => {

  // };

  const deleteUploadedFile = async (documentName) => {
    const payload = { documentType: 'AUTHORIZED_SIGNATORY', documentName };
    try {
      const { res, err } = await deleteDocumentsForSummary(payload, summaryAuthToken);
      if (res) {
        fetchOrderFn();
      }
    } catch (e) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      setToast(true, errorMsg, ERROR_TOAST);
      window.scrollTo(0, 0);
      console.error(e);
    }
  };

  const deleteAllImages = (props) => {
    const { doc1, doc2 } = props;
    // console.log(doc1, "doc1", doc2, "doc2");
    deleteUploadedFile(doc1);
    if (doc2 !== 'PAN_BACK') {
      deleteUploadedFile(doc2);
    }
    setUploadedDoc({});
    setSelectedOption(options[0]);

    setKdmAccordionValidation(false);
    setIsSaveBtnDisabled(true);
  };

  const onSuccessCb = (orderDetails) => {};

  const clearAllImages = () => {
    // setClearShowPopup(!showClearPopup);
    // removeAllDoc();
    // childRef && childRef.current && childRef.current.goToSlide(0, true);
    // console.log(uploadedDoc, 'clear');
    const uploadedDocumentType = Object.keys(uploadedDoc)[0]?.split('_')[0];
    // console.log(uploadedDocumentType);
    if (uploadedDocumentType === 'PAN') {
      deleteAllImages({ doc1: 'PAN_FRONT', doc2: 'PAN_BACK' });
    } else {
      deleteAllImages({ doc1: 'AADHAAR_FRONT', doc2: 'AADHAAR_BACK' });
    }
    // fetchOrderFn(null, summaryAuthToken, onSuccessCb)
  };

  const togglePopUp = (keyName) => {
    Object.keys(uploadedDoc).forEach((key) => {
      if (key === keyName) {
        setPopupImageUrl(uploadedDoc[key]);
        setTogglePopUp(!showPopUp);
      }
    });
    console.log();
    // setPopupImageUrl(imageUrl)
    // setTogglePopUp(!showPopUp)
  };

  // console.log(order);
  useEffect(() => {
    let sliderCurrentIndex = childRef && childRef.current && childRef.current.state && childRef.current.state.currentSlide ? childRef.current.state.currentSlide : 0;
    if (sliderIndex > 0 && sliderCurrentIndex < Object.keys(documentArray).length - 1) {
      if (sliderCurrentIndex < Object.keys(documentArray).length - 2) {
        childRef && childRef.current && childRef.current.goToSlide(sliderCurrentIndex + 1, true);
      }
    }
    // getDefaultSelectedOption()
  }, [sliderIndex]);

  useEffect(() => {
    // console.log(order, 'order');
    const authSignDocs = order?.documents?.AUTHORIZED_SIGNATORY;
    const obj = {};
    if (order?.documents?.AUTHORIZED_SIGNATORY) {
      authSignDocs &&
        Object.keys(authSignDocs).forEach((item) => {
          if (item !== 'KDM') {
            obj[item] = authSignDocs[item];
          }
        });
      setUploadedDoc(obj);
    }
  }, []);
  const renderDocCards = () =>
    Object.keys(documentArray).map((keyName, index) => (
      <UploadDocCard
        kdmImagePresent={kdmImagePresent}
        fetchOrderFn={fetchOrderFn}
        setKdmAccordionValidation={setKdmAccordionValidation}
        setIsSaveBtnDisabled={setIsSaveBtnDisabled}
        order={order}
        documentObj={documentArray}
        keyName={keyName}
        key={index}
        setAllDocUpload={setAllDocUpload}
        showAllDocUpload={showAllDocUpload}
        uploadedDoc={uploadedDoc}
        setUploadedDoc={setUploadedDoc}
        togglePopUp={togglePopUp}
        getOrderedImages={getOrderedImages}
        setSliderIndex={setSliderIndex}
        sliderIndex={sliderIndex}
        companyGstValidation={companyGstValidation}
      />
    ));
  return (
    <React.Fragment>
      <div className="doc-upload-area">
        {showPopUp && <PreviewComponent imageUrl={imageUrl} togglePopUp={togglePopUp} uploadedDoc={uploadedDoc} />}
        <div className="slides-indicator">
          <div className="doc-info">
            <div className="info">
              {documentArray && uploadedDoc && Object.keys(uploadedDoc).length > 0 && Object.keys(uploadedDoc).length !== Object.keys(documentArray).length && (
                <span className="text-success text-red">
                  {' '}
                  {Object.keys(uploadedDoc).filter((key) => key !== 'KDM').length} of {Object.keys(documentArray).length} documents uploaded.
                </span>
              )}
              <p className="upload-info-text">*The maximum file upload size is 5MB. File format should be either .PNG, .JPG, or .JPEG.</p>
            </div>
            {documentArray && uploadedDoc && Object.keys(uploadedDoc).filter((key) => key !== 'KDM').length === Object.keys(documentArray).length && (
              <div className="clear" onClick={clearAllImages} style={{ fontSize: '14px' }}>
                Clear All
              </div>
            )}
          </div>
        </div>
        {/* {
                    showClearPopup &&
                    <PopupComponent
                        toggleSelectPopUp={toggleClearPopUp}
                        popupData={{title:CLEAR_IMAGE_TITLE, message:CLEAR_IMAGE_MESSAGE, buttonYes:'Yes, Sure', buttonNo:'cancel' }}
                        onClickYes={clearAllImages}
                    />
                } */}
        <div className="document_carousel">
          <div className="carousel-control-new">
            <div className="doc_items">{renderDocCards()}</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

UploadDocuments.defaultProps = {
  moEngageKey: {}
};

export default UploadDocuments;
